// Import package
import React from "react";
import { Button, Space } from "antd";
import { PlusOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

// Import file
import PageContentWrapper from "../../components/PageContentWrapper";
import AdminListContainer from "../../containers/adminRole/admin/AdminListContainer";

// Component
export default function AdminPage() {
  return (
    <PageContentWrapper
      title="Admin"
      extra={
        <Space>
          <Link to="/admin/add">
            <Button icon={<PlusOutlined />} type="primary" style={{ margin: 0 }}>
              Tambah
            </Button>
          </Link>
          <Link to="/api-external">
            <Button icon={<UnorderedListOutlined />} type="primary" style={{ margin: 0 }}>
              Credential Api External
            </Button>
          </Link>
        </Space>
      }
    >
      <AdminListContainer />
    </PageContentWrapper>
  );
}
